import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import FishDetail from '../../Components/FishDetail';
import { AppContext } from '../../Context/AppContext';

function RouteFish({ match: { params: { fishId } } }) {
  return (
    <AppContext.Consumer>
      {(context) => {
        if (!context) {
          return null;
        }

        const { fish } = context;

        if (!fish) {
          return null;
        }

        const currentFish = fish.find(i => i.route === fishId);

        if (!currentFish) {
          return null;
        }

        return (
          <React.Fragment>
            <Helmet>
              <title>
                {`Fish Toronto | ${currentFish.name}`}
              </title>
            </Helmet>
            <FishDetail fish={currentFish} />
          </React.Fragment>
        );
      }}
    </AppContext.Consumer>
  );
}

RouteFish.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      experiment: PropTypes.string,
    }),
  }).isRequired,
};

export default RouteFish;



// WEBPACK FOOTER //
// ./src/Routes/RouteFish/index.jsx